const FALLBACK_ORIGIN = 'https://glovy-jewellery.onrender.com';
const TRUSTED_API_HOSTS = ['glovy-jewellery.onrender.com'];

const normalizeBase = (value) => String(value || '').trim().replace(/\/+$/, '');

const stripApiSuffix = (value) => normalizeBase(value).replace(/\/api$/i, '');

export const getApiBase = () => {
  const env = normalizeBase(process.env.REACT_APP_API_URL);
  if (!env || /localhost|127\.0\.0\.1/i.test(env)) return FALLBACK_ORIGIN;

  const resolved = stripApiSuffix(env);
  try {
    const host = new URL(resolved).hostname.toLowerCase();
    if (!TRUSTED_API_HOSTS.includes(host)) return FALLBACK_ORIGIN;
  } catch {
    return FALLBACK_ORIGIN;
  }

  return resolved;
};

export const getAssetBase = () => stripApiSuffix(getApiBase());

export const toAssetUrl = (path) => {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  const normalizedPath = String(path).startsWith('/') ? String(path) : `/${path}`;
  return `${getAssetBase()}${normalizedPath}`;
};

export const toOptimizedAssetUrl = (path, options = {}) => {
  const raw = toAssetUrl(path);
  if (!raw) return null;

  try {
    const parsed = new URL(raw);
    const marker = '/storage/v1/object/public/';
    const lastIdx = parsed.pathname.lastIndexOf(marker);
    if (lastIdx < 0) return raw;

    const assetPath = parsed.pathname.slice(lastIdx + marker.length);
    if (!assetPath) return raw;

    // Normalize duplicated Supabase object URLs to a single valid public object path.
    parsed.pathname = `/storage/v1/object/public/${assetPath}`;
    return parsed.toString();
  } catch {
    return raw;
  }
};
